import { getIdOrNull, requestWithPromise } from '..'
import { HttpMethods, makeQueryString } from '../apiHelper'
import apiClient from './apiClient'

export const getSchoolSectionYears = (section, user) => {
  return requestWithPromise(
    `/api/sections/${getIdOrNull(section)}/section-to-years`,
    HttpMethods.GET,
    null,
    user
  )
}

export const getActTypes = (user, section, parameters = { 'get-hours': 1 }) => {
  return requestWithPromise(
    `/api/school-sections/${getIdOrNull(section)}/act-types${makeQueryString(parameters)}`,
    HttpMethods.GET,
    null,
    user
  )
}

export const getSchoolSectionStudents = (user, schoolSection) => apiClient.get(user, `api/school-sections/${getIdOrNull(schoolSection)}/students`)

export const getSchoolSectionSectionStudents = (user, schoolSection) => apiClient.get(user, `api/school-sections/${getIdOrNull(schoolSection)}/section/students`)

export const addSchoolSection = (user, schoolSection) => apiClient.post(user, 'api/school-sections', schoolSection)
